<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="show_box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Create Question Bank
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center">
                <v-col sm="3" v-if="crs_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="crs" return-object
                        item-value="crs_id" :items="crs_list" item-text="crs_name" label="Subject" outlined
                        @change="getchapter()" />
                </v-col>
                <v-col sm="3" v-if="chapter_list != null && crs">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="chapter" item-value="ch_id"
                        :items="chapter_list" item-text="ch_name" label="Chapter" outlined
                        @change="getdifficultylevel()" />
                </v-col>
                <v-col sm="3" v-if="Level_list != null && chapter">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="Level" item-value="Level_id"
                        :items="Level_list" item-text="Level_name" label="Difficulty Level" outlined
                        @change="getQuestionBank()" />
                </v-col>
            </v-row>

            <v-row justify="center" v-if="Level">
                <!-- {{quiz_type_list}} -->
                <v-btn class="button" v-for="(qtype, index) in quiz_type_list" :key="index"
                    @click="add(qtype.quiz_type)">{{ qtype.display_name }}</v-btn>
                <!-- <v-btn class="button" @click="mcq_flag=false;subjective_flag=false;questionbank=true;live_mtp_flag=false;show_box=false;live_swa_flag=false;live_mwa_flag=false">View Question Bank</v-btn> -->
            </v-row>
        </v-card>
        <mcq v-if="mcq_flag == true" :type="type" :chapter="chapter" :crs="this.crs.crs_id" :Level="Level"></mcq>
        <livemtp v-if="live_mtp_flag == true" :quiztype="type" :chapter="chapter" :sel_crs="this.crs.crs_off_id"
            :from='this.from' :Level="Level"></livemtp>
        <livemwa v-if="live_mwa_flag == true" :quiztype="type" :chapter="chapter" :sel_crs="this.crs.crs_off_id"
            :from='this.from' :Level="Level"></livemwa>
        <liveswa v-if="live_swa_flag == true" :quiztype="type" :chapter="chapter" :sel_crs="this.crs.crs_off_id"
            :from='this.from' :Level="Level"></liveswa>
        <truefalse v-if="live_truefalse_flag == true" :quiztype="type" :chapter="chapter" :sel_crs="this.crs.crs_id"
            :from='this.from' :Level="Level"></truefalse>
        <subjective v-if="subjective_flag == true" :type="type" :chapter="chapter" :crs="this.crs.crs_id"
            :Level="Level"></subjective>
        <!-- <viewquestionbank v-if="questionbank== true"></viewquestionbank> -->
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import MCQ from "./MCQ";
import Subjective from "./Subjective";
import LiveMTP from "@/components/LiveClass/LiveMTPNew"
import LiveMultiWordAnswer from "@/components/LiveClass/LiveMultiWordAnswer"
import LiveSingleWordAnswer from "@/components/LiveClass/LiveSingleWordAnswer"
import LiveTrueFalse from "@/components/LiveClass/LiveTrueFalse"
// import ViewQuestionBank from "./ViewQuestionBank"
export default {
    components: {
        mcq: MCQ,
        livemtp: LiveMTP,
        livemwa: LiveMultiWordAnswer,
        liveswa: LiveSingleWordAnswer,
        subjective: Subjective,
        truefalse: LiveTrueFalse,
        // viewquestionbank:ViewQuestionBank,
    },
    //  props: {
    //          type:String
    //     },
    data() {
        return {
            coursechapterscard: true, show_card: false,
            questionbank: false,
            mcq_flag: false,
            live_mtp_flag: false, live_mwa_flag: false, live_swa_flag: false, live_truefalse_flag: false,
            subjective_flag: false,
            quiz_type_list: [],
            type: null,
            from: 'QB', show_box: true,


            quiz_type_list: [],
            Level_list: [],
            editorConfig: {
                height: "100px",
                extraPlugins: "mathjax",
                mathJaxLib:
                    "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: null,
            Level: null,
            overlay: false,
            crs_list: null,
            crs: null,
            chapter_list: null,
            chapter: null,
        };
    },
    updated: function () {
        this.$nextTick().then(() => {
            if (window.MathJax) {
                window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () => console.log("done"));
            }
        });
    },
    methods: {
        add(qtype) {
            //alert(qtype)
            if (qtype == "MCQ") {
                this.type = qtype
                this.mcq_flag = true; this.subjective_flag = false; this.questionbank = false, this.live_mtp_flag = false, this.live_swa_flag = false, this.live_mwa_flag = false, this.live_truefalse_flag = false
            }
            else if (qtype == "SUBJECTIVE") {
                this.type = qtype
                this.mcq_flag = false; this.subjective_flag = true; this.questionbank = false, this.live_mtp_flag = false, this.live_swa_flag = false, this.live_mwa_flag = false, this.live_truefalse_flag = false
            }
            else if (qtype == "MTP") {
                this.type = qtype
                this.live_mtp_flag = true; this.subjective_flag = false; this.questionbank = false, this.mcq_flag = false, this.live_swa_flag = false, this.live_mwa_flag = false, this.live_truefalse_flag = false
            }
            else if (qtype == "MultiWordAnswer") {
                this.type = qtype
                this.live_mtp_flag = false; this.subjective_flag = false; this.questionbank = false, this.mcq_flag = false, this.live_swa_flag = false, this.live_mwa_flag = true, this.live_truefalse_flag = false
            }
            else if (qtype == "SWA") {
                this.type = qtype
                this.live_mtp_flag = false; this.subjective_flag = false; this.questionbank = false, this.mcq_flag = false, this.live_swa_flag = true, this.live_mwa_flag = false, this.live_truefalse_flag = false
            }
            else if (qtype == "TrueFalse") {
                this.type = qtype
                this.live_mtp_flag = false; this.subjective_flag = false; this.questionbank = false, this.mcq_flag = false, this.live_swa_flag = false, this.live_mwa_flag = false, this.live_truefalse_flag = true
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getCourse() {
            axios
                .post("/QuizQuestionBank/getCourse")
                .then((res) => {
                    this.crs_list = res.data.crs_list;
                    this.quiz_type_list = res.data.quiz_type_list;
                })
                .catch((error) => {
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                })
                .finally(() => {
                    //close loader
                });
        },
        getchapter() {
            const data = {
                crs_id: this.crs.crs_id
            }
            axios
                .post("/QuizQuestionBank/getchapter", data)
                .then((res) => {
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", "Please add chapter for selected course !!!");
                        return
                    }
                    else {
                        this.chapter_list = res.data.chapter_list;
                    }
                })
                .catch((error) => {
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                })
                .finally(() => {
                    //close loader
                });
        },
        getdifficultylevel() {
            const data = {

            };
            axios
                .post("/QuizQuestionBank/getdifficultylevel", data)
                .then((res) => {
                    if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", "Please add Difficulty Level First..!!!");
                        return
                    }
                    else {
                        this.Level_list = res.data.difficulty_level_list;
                    }
                })
                .catch((error) => {
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                })
                .finally(() => {
                    //close loader
                });
        },
        getQuestionBank() {
            const data = {
                crs_id: this.crs.crs_id,
                ch_id: this.chapter,
                Level_id: this.Level,
                type: this.type
            }
            axios
                .post("/QuizQuestionBank/getQuestionBank", data)
                .then((res) => {
                    this.question_size = res.data.question_size
                    this.imagesize_new = res.data.imagesize / 1000
                    this.imagetype_new = res.data.imagetype
                })
                .catch((error) => {
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                })
                .finally(() => {
                    //close loader
                });
        }
    },
    mounted() {
        // alert(this.type)
        this.getCourse();
    },
};
</script>
<style scoped>
.radiospace {
    margin: 0.5rem !important;
    padding: 0%;
}

.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
}
</style>